import { toast } from "sonner";

interface Props {
  value: string;
  onClose: () => void;
}

export function KeyDisplayModal({ value, onClose }: Props) {
  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      toast.success("Clé copiée !");
    } catch {
      toast.error("Échec de la copie.");
    }
  }
  return (
    <div
      className="modal-overlay is-open"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal modal-sm">
        <div className="modal-title">
          Clé <em>widget</em> renouvelée
        </div>
        <p className="modal-body-text">
          Nouvelle clé API — à transmettre au client immédiatement. L'ancienne clé est définitivement invalidée.
        </p>
        <div className="key-box">{value}</div>
        <div className="modal-footer">
          <button type="button" className="btn-sm btn-ghost" onClick={copy}>
            Copier
          </button>
          <button
            type="button"
            className="btn-sm btn-primary"
            style={{ width: "auto", padding: "8px 20px" }}
            onClick={onClose}
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}
